var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isAuthenticated)?_c('Landing'):(_vm.isAuthenticated && _vm.me)?_c('MainAfterLogin'):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }